


//const databaseUrl = 'http://119.64.155.144:3000';
//const databaseNoport = 'http://119.64.155.144/happyfront/index.html#';


const databaseUrl = 'http://happycall2.synology.me:3000';
const databaseNoport = 'http://happycall2.synology.me/';



//const databaseUrl = 'http://127.0.0.1:3000';
//const databaseNoport = 'http://localhost:3001#';

//const databaseUrl = 'http://192.168.0.130:3000';
//const databaseNoport = 'http://192.168.0.130:3001#';



//const databaseUrl = 'http://192.168.50.40:3000';
//const databaseNoport = 'http://192.168.50.40:3001#';


export {databaseUrl,databaseNoport};



/*
const express = require('express');
const app = express();
const PORT = process.env.PORT || 4000;
//const bodyParser = require('body-parser');
const db = require('./config/db.js');

app.get('/mo',(req,res)=>{
    console.log('root');
})

app.listen(PORT, () => {
    console.log(`Server On : http://49.172.85.190:${PORT}`);
});

*/